import { api } from "./backend";

export function crear() {
  return {
    id: 0,
    sectorNombre: "",
  };
}

export function listar() {
  return api.get("sector/listar").then((r) => r.data);
}
